<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header @custom-event="getToken"></Header>
		
		<div class="page_content">
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span><a href="/tw/user/index">我的帳戶</a><span class="space">/</span>個人資訊
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->			
		</div>
		
		<div class="pub_div new_user_center_box">
			
			<!--左侧菜单-开始-->
			<UserLeftPannel :fileName="'profile'" :Token="this.token"></UserLeftPannel>
			<!--左侧菜单-结束-->
			
			<!--右侧内容-开始-->
			<div class="right_content_box">
				<h1>個人資訊</h1>
				<div class="user_main_box">
					
					<div class="items_box">
						<div class="item">
							<ul>
								<li>
									<h5>暱稱（必填)</h5>
									<el-input
									  placeholder="請輸入暱稱（必填）"
									  v-model="nickName"
									  ref="nickName"
									  maxlength="30"
									  clearable>
									</el-input>
								</li>
								<li>
									<h5>姓名</h5>
									<el-input
									  placeholder="請輸入姓名（非必填）"
									  v-model="userName"
									  ref="userName"
									  maxlength="50"
									  clearable>
									</el-input>
								</li>
								<li>
									<h5>手機</h5>
									<el-input
									  placeholder="請輸入手機號碼（非必填）"
									  v-model="mobile"
									  ref="mobile"
									  maxlength="50"
									  clearable>
									</el-input>
								</li>
								<li>
									<h5>固定電話</h5>
									<el-input
									  placeholder="請輸入固定電話（非必填）"
									  v-model="telphone"
									  ref="telphone"
									  maxlength="50"
									  clearable>
									</el-input>
								</li>
							</ul>
						</div>
						<div class="item">
							<ul>
								<li>
									<h5>公司名稱</h5>
									<el-input
									  placeholder="請輸入公司名稱（非必填）"
									  v-model="company"
									  ref="company"
									  maxlength="100"
									  clearable>
									</el-input>
								</li>
								<li>
									<h5>詳細地址</h5>
									<el-input
									  placeholder="請輸入请输入詳細地址（非必填）"
									  v-model="address"
									  ref="address"
									  maxlength="100"
									  clearable>
									</el-input>
								</li>
								<li>
									<h5>郵編</h5>
									<el-input
										style="width:40%"
									  placeholder="郵編"
									  v-model="zipcode"
									  ref="zipcode"
									  maxlength="20"
									  clearable>
									</el-input>
								</li>
								<li>
									<h5>國籍</h5>
									<el-select v-model="country" placeholder="請選擇國籍">
										<el-option
										v-for="item in countryList"
										:key="item.Id"
										:label="item.Title"
										width="100%"
										ref="country"
										:value="item.Title">
										</el-option>
									</el-select>
								</li>
							</ul>
						</div>
					</div>
					
					<div class="btns">
						<el-button type="primary" round :loading="btnLoading" @click="modify()">{{btnTxt}}</el-button>
						<el-button round plain onclick="location.href='index'">取消</el-button>
					</div>
					
				</div>
			</div>
			<!--右侧内容-结束-->
			
		</div>
		
		<Footer></Footer>
	</div>
</template>


<script>
	import {
		checkToken,
		getUserProfile,
		getCountry,
		userModify,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import UserLeftPannel from '@/components/tw_user_left_pannel.vue'
	export default {
		name: 'TW_UserProfile',
		mixins: [mixin],
		components: {
			Header,
			Footer,
			UserLeftPannel,
		},
		data() {
			return {
				fullscreenLoading: true, //loading状态
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				userDetail: {},
				
				nickName:'',
				userName:'',
				mobile:'',
				telphone:'',
				
				company:'',
				address:'',
				zipcode:'',
				country:'',
				countryList:[],
				
				btnLoading: false,
				btnTxt: '確定',
			}
		},
		created() {
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
					
					this.getCountry()
				}
				else				
				{
					this.$router.push({
						path: '/tw/user/login'
					})
				}
			},
			// 获取目的地列表
			async getCountry ()
			{
				const { data: res } = await getCountry(this.language)
				if (res.errcode === 0) {
					this.countryList = res.data
					
					this.getData()
				} else {
					this.$message.error(res.errmsg);
				}
			},
			//获取数据
			async getData() {
				const { data: res } = await getUserProfile(this.language, this.token, this.terminal)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.userDetail = res.data
					this.nickName = this.userDetail.NickName
					this.userName = this.userDetail.UserName
					this.mobile = this.userDetail.Mobile
					this.telphone = this.userDetail.Telephone					
					this.company = this.userDetail.Company
					this.address = this.userDetail.Address
					this.zipcode = this.userDetail.ZipCode
					this.country = this.userDetail.Country
				} else {
					this.errMessage = res.errmsg
				}
			},
			//提交
			async modify() {
				if(this.btnLoading)
				{
					return
				}
				
				if(this.nickName == '')
				{
					this.$message.error('請輸入昵稱');
					this.$refs.nickName.focus()
					return
				}
				if(this.nickName.length<2)
				{
					this.$message.error('暱稱長度不得小於2個字元');
					this.$refs.nickName.focus()
					return
				}
				
				this.btnLoading = true
				this.btnTxt = "保存中"
				this.fullscreenLoading = true
				
				//组装请求数据
				let userData = {
					NickName: this.nickName,
					UserName: this.userName,
					Mobile: this.mobile,
					Telephone: this.telphone,
					Company: this.company,
					Country: this.country,
					Address: this.address,
					ZipCode: this.zipcode,
				}
				let params={
					Language: this.language,
					Token: this.token,
					Terminal: this.terminal,
					UserData: userData
				}
				
				const { data: res } = await userModify(params)
				if (res.errcode === 0) {
					this.$message.success('修改成功');					
					this.timer = setTimeout(() => {
						this.$router.push({
							path: '/tw/user/index'
						})
					}, 500)
				} else {
					this.btnLoading = false
					this.btnTxt = "確定"
					this.fullscreenLoading = false
					this.$message.error(res.errmsg);
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.user_main_box {
		box-sizing: border-box;
		
		.items_box {
			display: flex;
			box-sizing: border-box;
			
			.item {
				width: 50%;
				box-sizing: border-box;
				padding-right: 50px;
				
				ul {
					
					li {
						margin-top: 30px;
						
						h5 {
							font-size: 15px;
							font-weight: 400;
							margin-bottom: 10px;
						}
					}
					li:first-child {
						margin-top: 0;
					}
				}
			}
			.item:last-child {
				padding-right: 0;
			}
		}
		
		.btns {
			margin-top: 40px;
			display: flex;
			box-sizing: border-box;
			
			.btn {
				width: 130px;
				font-size: 15px;
				height: 40px;
				line-height: 40px;
				box-sizing: border-box;
				padding: 0 20px;
				border: #008768 solid 1px;
				border-radius: 20px;
				color: #008768;
				cursor: pointer;
				-webkit-transition: all .3s ease;
				margin-right: 20px;
				text-align: center;
			}
			.save {
				background-color: #008768;
				border: #008768 solid 1px;
				color: #fff;				
			}
			.save:hover {
				background-color: #000;
				border: #000 solid 1px;
				color: #fff;	
			}
			.cancle {
				background-color: #fff;
				border: #666 solid 1px;
				color: #666;				
			}
			.cancle:hover {
				border: #008768 solid 1px;
				color: #008768;	
			}
		}
	}
	.el-select {
		width: 100%;
		border: #C4C4C4 solid 1px;
		border-radius: 5px;
		background-color: #fff;
		background-image: none;
		font-size: 15px;
		font-weight: 500;
		color: #000;
	}
	
	
	
	/*输入框*/
	.el-input {
		width: 100%;
		border: #C4C4C4 solid 1px;
		border-radius: 5px;
		background-color: #fff;
		background-image: none;
		font-size: 15px;
	}
	/deep/ .el-input__inner {
		background-image: none;
		font-weight: 400;
	}
	
	/*按钮*/
	.el-button {
		width: 130px;
		font-family: "PingFang SC", sans-serif, Helvetica, Arial;
		font-size: 15px;
		font-weight: 400;
		height: 42px;
		border-radius: 21px;
	}
	.el-button--default {
		border: #3D7856 solid 1px;
		color: #3D7856;
		margin-left: 20px;
		border-radius: 8px;
	}
	.el-button--default:hover {
		border: #3D7856 solid 2px;
		color: #3D7856;
	}
	.el-button.is-plain:focus  {
		border: #3D7856 solid 1px;
		color: #3D7856;
	}
	
	.el-button--primary {
		border: 0;
		border-radius: 8px;
	}		
	.el-button--primary:focus {
		background-color: #3D7856;
	}
	.el-button--primary:hover {
		background-color: #000;
	}
</style>